import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import { format } from "date-fns";
import { Button, Labeled } from "@lifepay/rc-ui-toolkit";

// import Badge from "components/visual/Badge";

import styles from "./Person.m.scss";

function Person(props) {
  const { theme, client, workWithClient } = props;

  return (
    <div className={classnames(theme.wrapper)}>
      <div className={classnames(theme.summary)}>
        <Labeled
          label={"Ф.И.О."}
          theme={{ wrapper: theme.item, label: theme.label }}
        >
          {client.clientName || "-"}
        </Labeled>
        <Labeled
          label={"Дата Рождения"}
          theme={{ wrapper: theme.item, label: theme.label }}
        >
          {client.birthDate ? format(client.birthDate, "DD.MM.YYYY") : "-"}
        </Labeled>
        <Labeled
          label={"Телефон"}
          theme={{ wrapper: theme.item, label: theme.label }}
        >
          {client.phone || "-"}
        </Labeled>
        <Labeled
          label={"Паспорт"}
          theme={{ wrapper: theme.item, label: theme.label }}
        >
          {`${client.passportSer || "-"} ${client.passportNum || "-"}`}
        </Labeled>
        <Labeled
          label={"Email"}
          theme={{ wrapper: theme.item, label: theme.label }}
        >
          {client.email || "-"}
        </Labeled>
        <Button
          theme={{ wrapper: theme.button }}
          size={"small"}
          type={"alt"}
          onClick={() =>
            workWithClient({ type: "PERSON", id: client.clientId })
          }
        >
          {"Работать с клиентом"}
        </Button>
      </div>
    </div>
  );
}

Person.displayName = "Person";

Person.propTypes = {
  theme: PropTypes.object,
  client: PropTypes.object,
  workWithClient: PropTypes.func,
};

Person.defaultProps = {};

export default themr("@lifepay/Person", styles)(Person);



// WEBPACK FOOTER //
// ./src/components/client-search/Person/Person.js